import React, { Component } from 'react';
// import ReactDOM from "react-dom";
import { connect } from 'react-redux';
// import * as Contracts from '../../Store/Contracts';
import * as RemittanceLogCheck from './Saga/RemittanceLogCheck';
import Button from '@material-ui/core/Button';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import NetworkWifiIcon from '@material-ui/icons/NetworkWifi';
import RouterIcon from '@material-ui/icons/Router';
import KitchenIcon from '@material-ui/icons/Kitchen';
import CallIcon from '@material-ui/icons/Call';
import Brightness5Icon from '@material-ui/icons/Brightness5';
import './Css/Grid.css';
import moment from 'moment'

const ReactDataGrid = require('react-data-grid');
interface Props {
  // get_banks: any,
  owner_remittance_check_logs: [],
  owner_remittance_check_logs_list: [],
  // shops: any,
  // parking_checked: any,
  // parking_check_loading: number,
  // energization_checked: any,
  // energization_check_loading: number,
  // net_checked: any,
  // net_check_loading: number,

  // electronics_checked: any,
  // electronics_check_loading: number,

  // wifi_checked: any,
  // wifi_check_loading: number,
  // completed_checked: any,

  // owner_tel_check_loading: number,
  // owner_tel_checked: any,

  // columns:[],

}



interface State {
  columns: any
  refresh: boolean
  // state types
}


const DateFormatter = (payload: any) => {
  if (payload.value) {
    return moment(payload.value).format("YYYY/MM/DD");
  } else {
    return "";
  }
};
const nameFormatter = (payload: any) => {
  if (payload.row.name2) {
    return <div><div>{payload.row.name1}</div><div style={{ fontSize: "10px" }} >{payload.row.name2}</div ></div >
  } else {
    return payload.row.name1;
  }
};

const netFormatter = (payload: any) => {
  if (payload.value) {
    return <div style={{ marginLeft: "10px" }}>{payload.value}</div >

  } else {
    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};

const parkingFormatter = (payload: any) => {
  if (payload.value && payload.row.counting === 1) {
    return ""

  } else {
    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};
const electronicsFormatter = (payload: any) => {
  if (payload.value) {
    return ""

  } else {
    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};


const energizationFormatter = (payload: any) => {
  if (payload.value) {
    return ""

  } else {
    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};

const wifiFormatter = (payload: any) => {
  if (payload.value !== 2 && payload.row.net && (parseInt(payload.row.net_gyosha_no) === 1 || parseInt(payload.row.net_gyosha_no) === 2)) {
    return ""

  } else {

    return <div style={{ background: payload.row.is_cancel === 1 ? "pink" : payload.row.counting === 2 ? "#f5f5f5" : "#CCC", height: "100px" }}>　</div >
  }
};


const saFormatter = (payload: any) => {


  return payload.row.so_gak - payload.row.so_gak2
};
// const SelectFormatter =(payload:any) => {
//   console.log(payload)
//   if(payload.row.receipt_at && payload.row.payment_at){
//     // return moment(payload.value).format("YYYY/MM/DD");
//     return <div>　</div>
//   }else{
//     return <div  style={{background:"#CCC"}}>　</div>;
//   }
//   };


const RowRenderer = ({ renderBaseRow, ...props }: any) => {
  //console.log(props)
  //const color = props.idx % 2 ? "green" : "blue";

  let backgroundColor = ""
  if (props.row.is_cancel === 1) {
    backgroundColor = " row-highlight-pink";
  } else if (props.row.counting === 2) {
    backgroundColor = " row-highlight-smoke";
  }

  //divだと描画が震える　.border-bottoms>div>div 　アンダーバーは←のように指定
  return <span className={backgroundColor}>{renderBaseRow(props)}</span>;



};





const defaultColumnProperties = {
  sortable: true,
  // width: 120
};






/**
 *会計連動グリッド
 *
 * @class AccountingGridComponent
 * @extends {Component<Props, State>}
 */
class AccountingGridComponent extends Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);
    this.onRowClick = this.onRowClick.bind(this);

    this.state = {
      refresh: false,
      columns: [
        { key: 'so_no', name: '家主No', width: 60, resizable: true },
        { key: 'so_name', name: '家主名', width: 150, resizable: true },
        { key: 'so_ymd', name: '送金日', width: 100, resizable: true, formatter: DateFormatter },
        { key: 'bk_no', name: '物件No', width: 60, resizable: true },
        { key: 'bk_name', name: '物件名', width: 150, resizable: true },
        { key: 'so_gak', name: '送金額', width: 100, resizable: true },
        { key: 'so_gak2', name: '印刷時送金額', width: 100, resizable: true },
        { key: 'sa', name: '差額', width: 100, resizable: true },
        { key: 'created_at', name: '更新日', width: 100, resizable: true },

        // { key: 'name1', name: '契約者名', width: 150, resizable: true },

        // { key: 'Tenpo_Name', name: '店舗', width: 80, resizable: true },
        // { key: 'user_name', name: '担当', width: 50, resizable: true },

        // // { key: 'amount', name: '金額', width: 80,resizable: true },

        // // { key: 'pay_way', name: '支払方法', width: 80,resizable: true },
        // // { key: 'tatemonoAddress1', name: '建物住所', width: 100,resizable: true },
        // { key: 'building_name', name: '建物名', width: 150, resizable: true },
        // { key: 'room_name', name: '部屋名', width: 60, resizable: true },


        // { key: 'electronics', name: '家電', width: 60, resizable: true, formatter: electronicsFormatter },
        // { key: 'parking', name: '駐車場', width: 60, resizable: true, formatter: parkingFormatter },
        // { key: 'net', name: 'ネット', width: 150, resizable: true, formatter: netFormatter },
        // { key: 'wifi', name: 'wifi', width: 60, resizable: true, formatter: wifiFormatter },

        // { key: 'energization', name: '通電', width: 60, resizable: true, formatter: energizationFormatter },
        // { key: 'owner_tel', name: '家主TEL', width: 60, resizable: true, formatter: ownerFormatter },
        // // { key: 'is_cancel', name: 'キャンセル', width: 60, resizable: true },

        // { key: 'office_check_completed', name: '消込', width: 60, resizable: true },
        // {key: 'start_at', name: '始期日', width: 80, resizable: true, formatter: DateFormatter },
        // { key: 'end_at', name: '終了日',width: 80, resizable: true, formatter: DateFormatter },
        // { key: 'receipt_at', name: '領収日',width: 80, resizable: true, formatter: DateFormatter },
        // { key: 'payment_at', name: '入金日',width: 80, resizable: true, formatter: DateFormatter},

        // { key: 'rent_contract_name1', name: '契約者名',width: 80, resizable: true},
        // { key: 'rent_contract_tatemono_name', name: '建物名',width: 100, resizable: true},
        // { key: 'rent_contract_room_name', name: '部屋名',width: 60, resizable: true},
        // { key: 'contract_money', name: '契約金',width: 60, resizable: true },

        // { key: 'accounting_output_at', name: '出力日',width: 100, resizable: true },

      ].map(c => ({ ...c, ...defaultColumnProperties }))
    };

    this.sortRows = this.sortRows.bind(this);
    // this.SectionFormatter = this.SectionFormatter.bind(this);
    // this.getCellActions = this.getCellActions.bind(this);
    this.getRowCount = this.getRowCount.bind(this);

  }





  // SectionFormatter = (payload: any) => {

  //   const result = this.props.shops.filter((x: any) => x.tenpoNo === payload.value);

  //   return result[0].tenpoName;

  // };


  componentWillMount() {

    // this.props.get_banks({output:true,name:"",date1:"",date2:""})


  }
  getSelectedCell(event: any) {
    alert()
  }

  onRowClick = (rowIdx: any, row: any) => {




  }


  // rowGetter = (i:number) => {
  //     return this.props.rent_contracts_list[i];
  //   };

  onRowsSelected = (rows: any) => {
    console.log(rows)
    rows.forEach(function (r: any) {
      r.row.selected = true;
    });

    this.forceUpdate();

  };

  onRowsDeselected = (rows: any) => {

    rows.forEach(function (r: any) {
      r.row.selected = false;
    });
    this.forceUpdate();
  };

  sortRows = (initialRows: any, sortColumn: any, sortDirection: any) => {


    const comparer = (a: any, b: any) => {
      // if (sortColumn === "created_at") {
      //   if (sortDirection === "ASC") {

      //     return new Date(a[sortColumn]) > new Date(b[sortColumn]) ? 1 : -1;
      //   } else if (sortDirection === "DESC") {
      //     return new Date(a[sortColumn]) < new Date(b[sortColumn]) ? 1 : -1;
      //   } else {
      //     return 1;
      //   }
      // } else {

      if (sortDirection === "ASC") {

        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      } else {
        return 1;
      }
      // }
    };


    this.setState({
      refresh: !this.state.refresh
    });
    return sortDirection === "NONE" ? initialRows : this.props.owner_remittance_check_logs_list.sort(comparer);
  };




  getRowCount() {
    let count = this.props.owner_remittance_check_logs_list.length;
    if (this.state.refresh && count > 0) {
      count--; // hack for update data-grid
      this.setState({
        refresh: false
      });
    }

    return count;
  }



  render() {

    return (
      <div id="contractcheck">

        <ReactDataGrid
          // ref={node => this.grid = node}
          enableCellSelect={false}
          columns={this.state.columns}
          rowGetter={(i: number) => this.props.owner_remittance_check_logs_list[i]}
          // getCellActions={this.getCellActions}
          rowsCount={this.getRowCount()}
          headerRenderer={true}
          dragable={true}
          rowRenderer={RowRenderer}
          // onColumnResize={(idx, width) =>
          //     console.log(`Column ${idx} has been resized to ${width}`)
          // }
          // emptyRowsView={this.EmptyRowsView}
          // onRowClick={this.onRowClick}
          // rowSelection={{
          //     showCheckbox: true,
          //     enableShiftSelect: true,
          //     onRowsSelected: this.onRowsSelected,
          //     onRowsDeselected: this.onRowsDeselected,
          //     selectBy: {
          //       isSelectedKey: 'selected'
          //       // indexes: this.state.selectedIndexes
          //     }
          //   }}
          onGridSort={(sortColumn: any, sortDirection: any) => { this.sortRows(this.props.owner_remittance_check_logs_list, sortColumn, sortDirection) }
            //
          }
          //onCellSelected={this.getSelectedCell}
          minHeight={600} />
      </div>
    );
  }


}



const mapStateToProps = (state: any) => {
  return {
    user_details: state.masterReducer.user_details,
    shops: state.masterReducer.shops,
    owner_remittance_check_logs: state.RemittanceLogCheck.owner_remittance_check_logs,

    owner_remittance_check_logs_list: state.RemittanceLogCheck.owner_remittance_check_logs_list,
    // parking_check_loading: state.ContractCheck.owner_remittance_check_logs_list,
    // energization_check_loading: state.ContractCheck.energization_check_loading,
    // net_check_loading: state.ContractCheck.net_check_loading,
    // electronics_check_loading: state.ContractCheck.electronics_check_loading,
    // wifi_check_loading: state.ContractCheck.wifi_check_loading,
    // owner_tel_check_loading: state.ContractCheck.owner_tel_check_loading,

  }
}
function mapDispatchToProps(dispatch: any) {
  return {

    // parking_checked(state: any) {
    //   dispatch(RemittanceLogCheck.parking_checked(state))
    // },
    // energization_checked(state: any) {
    //   dispatch(RemittanceLogCheck.energization_checked(state))
    // },
    // net_checked(state: any) {
    //   dispatch(RemittanceLogCheck.net_checked(state))
    // },
    // electronics_checked(state: any) {
    //   dispatch(RemittanceLogCheck.electronics_checked(state))
    // },
    // wifi_checked(state: any) {
    //   dispatch(RemittanceLogCheck.wifi_checked(state))
    // },
    // completed_checked(state: any) {
    //   dispatch(RemittanceLogCheck.completed_checked(state))
    // },

    // owner_tel_checked(state: any) {
    //   dispatch(RemittanceLogCheck.owner_tel_checked(state))
    // },

    // bind_kyousai_contract(state: any) {
    //   dispatch(ContractSearch.bind_kyousai_contract(state))
    // },
    //   get_banks(state:any) {
    //     dispatch(Kyousai.get_banks(state))
    // },

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountingGridComponent);